export enum StageType {
  POSITIVE = "positive",
  NEGATIVE = "negative",
  DEFAULT = "default",
}

export type OrgStages = {
  stage_id: string;
  label: string;
  color?: string;
  stage_order: number;
  stage_type?: StageType;
  is_default: boolean;
  is_active: boolean;
  deleted_at?: Date | null;
  probability: number;
  modified_by?: string;
  pipeline_id?: string;
  name?: string;
};

export type UpdateStagesOrdersData = {
  stage_id: string;
  stage_order: number;
};

export type EditableStageData = {
  label?: string;
  color?: string;
  probability?: number;
  is_default?: boolean;
  stage_type?: StageType;
};

export type UpdateOrgStageDataByIdBody = {
  stage_id: string;
  stageData: EditableStageData;
};

export type CreateNewOrgStageBody = {
  label: string;
  color?: string;
  stage_order: number;
  is_default?: boolean;
  probability?: number;
  pipeline_id: string;
};
